import { Component, Input } from '@angular/core';
import { ProductWarehouseSeasonality } from 'src/app/models';
import { GenericResource } from 'src/app/resources';

@Component({
    selector: 'app-product-warehouse-seasonalities',
    templateUrl: './product-warehouse-seasonalities.component.html',
    styleUrls: ['./product-warehouse-seasonalities.component.sass'],
    standalone: false
})
export class ProductWarehouseSeasonalitiesComponent {

  @Input() seasonalities?:GenericResource<ProductWarehouseSeasonality>;
}
